<template>
    <div>
        <md-empty-state
                md-icon="timer"
                md-label="Coming Soon"
                md-description="Please bear with us while we develop this feature. Stay tuned!">
        </md-empty-state>
    </div>
</template>

<script>
    export default {
        name: "GetTrustScore"
    }
</script>

<style scoped>

</style>